import { getValue } from '../GetValueHelper';

function contentFieldMapped(prev: any, contentField: any) {
  const obj = {} as any;
  const name = getValue(contentField, 'name', '');
  const dataType = getValue(contentField, 'dataType', '');
  const repeatable = !!contentField.repeatable || false;
  const nestedContentFields = getValue(contentField, 'nestedContentFields', []);

  let value = '';

  if (dataType !== '' && !repeatable && nestedContentFields.length === 0) {
    if (dataType === 'document') {
      value = getValue(
        contentField,
        'contentFieldValue.document.contentUrl',
        '',
      );
    }

    if (['html', 'string', 'integer'].includes(dataType)) {
      value = getValue(contentField, 'contentFieldValue.data', '');
    }

    if (dataType === 'image') {
      value = getValue(contentField, 'contentFieldValue.image.contentUrl', '');
    }

    obj[name] = value;
  } else {
    if (!repeatable && nestedContentFields.length > 0) {
      if (dataType === 'image') {
        obj[name] = nestedContentFields.reduce(contentFieldMapped, {
          image: getValue(
            contentField,
            'contentFieldValue.image.contentUrl',
            '',
          ),
        });
      } else {
        obj[name] = nestedContentFields.reduce(contentFieldMapped, {});
      }
    }

    if (repeatable && nestedContentFields.length > 0) {
      const temp = nestedContentFields.reduce(contentFieldMapped, {});

      if (!Array.isArray(prev[name])) {
        obj[name] = [temp];
      } else {
        obj[name] = [...prev[name], temp];
      }
    }
  }

  return { ...prev, ...obj };
}

export function getItems(data: any) {
  const items: any[] = [];
  data.items.forEach((item: any) => {
    const initial = {
      id: item.title,
    };
    const obj = item.contentFields.reduce(contentFieldMapped, initial);
    items.push(obj);
  });
  return items;
}
